<template>
  <b-modal :active.sync="isModalActive" has-modal-card @close="cancel">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <b>Recusar Acesso</b>
        </p>
        <button type="button" class="delete" @click="cancel" />
      </header>
      <section class="modal-card-body">
        <b-field label="Motivo">
          <b-input maxlength="200" type="textarea" v-model="motivoRecusa" placeholder="Digite o motivo da recusa ..."></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button type="is-success" @click="confirmar"> Confirmar </b-button>
        <b-button
          native-type="button"
          type="is-danger"
          outlined
          @click="cancel"
        >
          Cancelar
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalRecusarAcesso",
  props: {
    isActive: Boolean,
    item: Number,
  },
  emits: ["cancel", "confirm"],
  data() {
    return {
      isModalActive: this.isActive,
      motivoRecusa: null,
    };
  },
  methods: {
    confirmar() {
      const payload = {
        id: this.item,
        motivoRecusa: this.motivoRecusa,
      };
      this.$emit("confirm", payload);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  watch: {
    isActive(newVal) {
      this.isModalActive = newVal; // Sincroniza o estado do modal com a prop isActive
    },
  },
});
</script>
